interface ScorePanelProps {
  score: number;
  highScore: number;
}

export default function ScorePanel({ score, highScore }: ScorePanelProps) {
  return (
    <div className="flex justify-between w-full mb-6">
      <div className="bg-[#bbada0] rounded-lg px-4 py-2 w-[48%]">
        <div className="score-label">SCORE</div>
        <div className="score-value">{score}</div>
      </div>
      
      <div className="bg-[#bbada0] rounded-lg px-4 py-2 w-[48%]">
        <div className="score-label">BEST</div>
        <div className="score-value">{highScore}</div>
      </div>
    </div>
  );
}